import { SiteSummary } from './site-summary.model';
import {SiteDefaultValues} from './site-default-values.model';
import {Address, Contact} from '@rbaip/address-form';

export class Site {
  id: number;
  name: string;
  description?: string;
  address?: Address;
  titleContact: Contact;
  siteStatus?: string;
  siteUseType?: string;
  mvDealerNumber?: string;
  defaultBusinessUnit?: string;
  cityProvinceCountry: string;
  selected: boolean;
  summary: SiteSummary;
  siteDefaultValues: SiteDefaultValues;

  public static fromSiteJson(siteJson: any): Site {
    const site: Site = Object.assign(siteJson);
    if (site.address) {
      site.address = Address.fromJsonString(site.address);
    }
    if (site.titleContact) {
      site.titleContact = Contact.fromJsonString(site.titleContact);
    }
    return site;
  }

  clone(site: Site) {
    this.id = site.id;
    this.name = site.name;
    this.description = site.description;
    this.address = site.address ? site.address.clone() : site.address;
    this.siteStatus = site.siteStatus;
    this.siteUseType = site.siteUseType;
    this.mvDealerNumber = site.mvDealerNumber;
    this.defaultBusinessUnit = site.defaultBusinessUnit;
    this.cityProvinceCountry = site.cityProvinceCountry;
    this.summary = site.summary;
    this.selected = false;
  }
}
